(function () {
  /* Shopify money formatting – supports every Shopify amount placeholder */
  const money = (cents) => {
    const fmt = window.SP_MONEY_FORMAT || '{{amount_with_space_separator}} kr';
    const value = Number(cents) || 0;
    const group = (amount, decimals, thousands, decimal) => {
      const fixed = (amount / 100).toFixed(decimals);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? whole + decimal + parts[1] : whole;
    };
    const formats = {
      amount: () => group(value, 2, ',', '.'),
      amount_no_decimals: () => group(value, 0, ',', '.'),
      amount_with_comma_separator: () => group(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => group(value, 0, '.', ','),
      amount_with_space_separator: () => group(value, 2, ' ', ','),
      amount_no_decimals_with_space_separator: () => group(value, 0, ' ', ','),
      amount_with_apostrophe_separator: () => group(value, 2, "'", '.'),
      amount_with_period_and_space_separator: () => group(value, 2, ' ', '.')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => (formats[key] ? formats[key]() : formats.amount()));
  };

  /* Mobile nav */
  const nav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-open-nav]').forEach((b) => b.addEventListener('click', () => nav && nav.classList.add('is-open')));
  document.querySelectorAll('[data-close-nav]').forEach((b) => b.addEventListener('click', () => nav && nav.classList.remove('is-open')));

  /* Gallery */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('.gallery__main img');
    g.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      if (!main) return;
      main.src = t.dataset.src;
      main.srcset = '';
      g.querySelectorAll('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
    }));
  });

  /* Bundles -> quantity */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const qty = form.querySelector('[name="quantity"]');
    form.querySelectorAll('[data-bundle]').forEach((r) => r.addEventListener('change', () => { qty.value = r.value; }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn.disabled = true;
      try {
        const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number(qty.value) || 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCart(true);
      } catch (err) {
        form.submit();
      } finally {
        btn.disabled = false;
      }
    });
  });

  /* Sticky add to cart */
  const sticky = document.querySelector('[data-sticky-atc]');
  const mainBtn = document.querySelector('[data-main-atc]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainBtn);
    sticky.querySelector('button').addEventListener('click', () => mainBtn.click());
  }

  /* Cart drawer */
  const drawer = document.querySelector('[data-cart-drawer]');
  const body = drawer && drawer.querySelector('[data-cart-body]');
  const total = drawer && drawer.querySelector('[data-cart-total]');
  const foot = drawer && drawer.querySelector('[data-cart-foot]');
  const open = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
  document.querySelectorAll('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); refreshCart(true); }));
  drawer && drawer.querySelectorAll('[data-close-cart]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { drawer && close(); nav && nav.classList.remove('is-open'); } });

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function refreshCart(openAfter) {
    if (!drawer) return;
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    document.querySelectorAll('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p>' + esc(drawer.dataset.emptyText) + '</p><button class="btn btn--outline" data-close-cart type="button">' + esc(drawer.dataset.continueText) + '</button></div>';
      body.querySelector('[data-close-cart]').addEventListener('click', close);
      foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map((it) => {
        const img = it.image ? '<img src="' + esc(it.image) + '&width=160" alt="" loading="lazy">' : '';
        const was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        const cmp = (it.compare_at_price || 0) * it.quantity;
        const wasCmp = !was && cmp > it.final_line_price ? '<s>' + money(cmp) + '</s>' : '';
        return '<div class="line"><div class="line__img">' + img + '</div><div><a class="line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<div class="qty"><button type="button" aria-label="−" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="+" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '">+</button></div></div>' +
          '<div class="line__price">' + money(it.final_line_price) + was + wasCmp + '</div></div>';
      }).join('');
      body.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', async () => {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.qty, quantity: Number(b.dataset.to) }) });
        refreshCart(false);
      }));
      total.textContent = money(cart.total_price);
      foot.hidden = false;
    }
    if (openAfter) open();
  }

  /* FAQ filter */
  document.querySelectorAll('[data-faq]').forEach((faq) => {
    faq.querySelectorAll('[data-faq-filter]').forEach((b) => b.addEventListener('click', () => {
      const cat = b.dataset.faqFilter;
      faq.querySelectorAll('[data-faq-filter]').forEach((x) => x.classList.toggle('is-active', x === b));
      faq.querySelectorAll('[data-faq-cat]').forEach((d) => { d.hidden = cat !== 'alle' && d.dataset.faqCat !== cat; });
    }));
  });
})();
